import 'whatwg-fetch';

import { unauthorizedConfig, config, fake, get, getStream, post, put, httpPatch, httpDelete, postFormData } from './rest-api-calls';
import { getThunk, getStreamThunk, postThunk, putThunk, patchThunk, deleteThunk, shouldExecute } from './dispatch-thunk';
import { fetchActions } from './fetch-actions';
import { apiCallReducer, ApiCallState } from './fetch-reducer';

export {
  config,
  unauthorizedConfig,
  fake,
  get,
  getStream,
  post,
  put,
  httpPatch,
  httpDelete,
  postFormData,
  getThunk,
  getStreamThunk,
  postThunk,
  putThunk,
  patchThunk,
  deleteThunk,
  shouldExecute,
  fetchActions,
  apiCallReducer,
  ApiCallState,
}



// WEBPACK FOOTER //
// src/api/index.js